// import axios from "axios";
// import { getAccessToken } from "utils";
// import { authRouteConstants } from "constants/routeConstants";
// import { API_URL } from 'constants/appConstants';

// const instance = axios.create({
//     baseURL: API_URL,
//     headers: {
//         Accept: "application/json",
//         "domain-name": (function () {


//             return window.location.host;
//             // return 'https://logotest.webbieshop.com/'
//             // return 'https://thegnhomehaven.webbieshop.com'
//             // return 'nitintest52.webbieshop.com'
//             // return 'cycelStore.webbieshop.com'
//             // return 'accessories.webbieshop.com'
//             // return 'demowebbie.webbieshop.com'
//             // return 'istore.webbieshop.com'
//             // return 'thevetstore.webbieshop.com'
//             // return 'testing-sites.webbieshop.com'
//             // return 'PGtest.webbieshop.com'
//             // return "andrewteachescoding.webbieshop.com"

//             // return  'mclardies.webbieshop.com'
//             // return 'd6-demo.webbieshop.com' //for d6 live demo enviroment
//         })(),
//     }
// });

// instance.interceptors.request.use(
//     function (config) {
//         const token = getAccessToken();
//         if (token)
//             config.headers['Authorization'] = `Bearer ${token}`;
//         return config;
//     }
// )

// instance.interceptors.response.use(
//     function (response) {
//         return response;
//     },
//     function (error) {
//         if (error && error.response && error.response.status === 401) {
//             if (error.response.data && error.response.data.code === "token_not_valid") {
//                 window.location.href = authRouteConstants.LOGOUT
//             }
//         }
//         return error
//     }
// );

// export default instance;

import axios from "axios";
import { getAccessToken, refreshToken } from "utils";
import { authRouteConstants } from "constants/routeConstants";
import { API_URL } from "constants/appConstants";
import { jwtDecode } from "jwt-decode";

const instance = axios.create({
    baseURL: API_URL,
    headers: {
        Accept: "application/json",
        "domain-name": (function () {
            return window.location.host;
            return 'testing-sites.webbieshop.com'
            return 'mclardies.webbieshop.com'
            return 'http://demostore.webbieshop.com/'
            return 'http://demostore.webbieshop.com/'
            return 'http://demostore.webbieshop.com/'
            return 'democafe.webbieshop.com'
            return 'http://demostore.webbieshop.com/'
            return 'https://makwa-it.webbieshop.com/'
            // return 'https://logotest.webbieshop.com/'
            // return 'https://thegnhomehaven.webbieshop.com'
            // return 'nitintest52.webbieshop.com'
            // return 'cycelStore.webbieshop.com'
            // return 'accessories.webbieshop.com'
            // return 'demowebbie.webbieshop.com'
            // return 'istore.webbieshop.com'
            return 'd6-demo.webbieshop.com'
            return 'alltypestore.webbieshop.com'
            return 'thevetstore.webbieshop.com'
            return 'thevetstore.webbieshop.com'
            // return 'PGtest.webbieshop.com'
            // return "andrewteachescoding.webbieshop.com"
            // return 'testing-sites.webbieshop.com'
            // return  'alora.webbieshop.com'
            return 'd6-demo.webbieshop.com' //for d6 live demo enviroment
            // return "slackoff.webbieshop.com/"
        })(),
    }
});

let isRefreshing = false; // Flag to prevent multiple refresh calls
let refreshPromise = null; // Store the refresh promise

const isTokenExpiringSoon = (token, bufferTime = 600) => {
    // const isTokenExpiringSoon = (token, bufferTime = 86390) => {
    try {
        const { exp } = jwtDecode(token);
        const currentTime = Math.floor(Date.now() / 1000);
        return exp - currentTime < bufferTime;
    } catch (error) {
        return true; // Assume expired if decoding fails
    }
};

instance.interceptors.request.use(async (config) => {
    let token = getAccessToken();

    if (token) {
        if (isTokenExpiringSoon(token)) {
            if (!isRefreshing) {
                isRefreshing = true;
                refreshPromise = refreshToken(); // Call refresh token only once
                token = await refreshPromise; // Wait for refresh to complete
                isRefreshing = false;
            } else {
                token = await refreshPromise; // Wait for the ongoing refresh
            }
        }
        config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
});

instance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error?.response?.status === 401) {
            if (error.response.data?.code === "token_not_valid") {
                window.location.href = authRouteConstants.LOGOUT;
            }
        }
        return (error);
    }
);

export default instance;
